<div class="row">
  <div class="col-md-12">
    <span mat-dialog-close matSuffix class="float-right">
      <mat-icon>close</mat-icon>
    </span>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <!--Title-->
  <div class="row row_flex mt-3">
    <div class="col-md-12">
      <label class="MM30 font-weight-bold"
        >Welcome to
        <span class="MM30" style="color: #013cdb">TrueCover’s</span>
      </label>
      <span class="title_divider"></span>
    </div>
    <div class="col-md-12" style="margin-top: 1rem">
      <label class="MM30 font-weight-bold">Integrated mail box!</label>
    </div>
    <div class="col-md-12 mt-3">
      <div class="underline"></div>
    </div>
  </div>

  <div class="row row_flex">
    <div class="col-md-12">
      <span class="MM24 font-weight-bold" *ngIf="data.configType === 'gmail'">
        Sign up using Gmail
        <img style="width: 2.375rem; height: 1.75rem;" class="ml-3" src="../../../../assets/icons/Shared/gmail.png" />
      </span>
      <span class="MM24 font-weight-bold" *ngIf="data.configType === 'yahoo'">
        Sign up using Yahoo
        <img style="width: 2.375rem; height: 1.75rem;" class="ml-3" src="../../../../assets/icons/Shared/yahoo.png" />
      </span>
      <span class="MM24 font-weight-bold" *ngIf="data.configType === 'outlook'">
        Sign up using Outlook
        <img style="width: 2.375rem; height: 1.75rem;" class="ml-3" src="../../../../assets/icons/Shared/outlook.png" />
      </span>
      <span class="MM24 font-weight-bold" *ngIf="data.configType === 'other'">
        Sign up using Other Mail
      </span>
    </div>
  </div>

  <!--Gmail Input Fields-->
  <div class="row row_flex mb-4" *ngIf="data.configType != 'other'">
    <div class="col-md-6">
      <mat-label class="label-flex">
        Username <span class="text-danger">*</span>
      </mat-label>
      <mat-form-field
        class="example-full-width field-fLex MM16"
        style="vertical-align: middle"
        floatLabel="never"
      >
        <input type="text" #search [formControl]="gmailUser" matInput />
        <mat-error
          class="error_flex"
          *ngIf="gmailUser.touched && gmailUser.hasError('required')"
        >
          Enter Username
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-label class="label-flex">
        Password <span class="text-danger">*</span>
      </mat-label>
      <mat-form-field
        class="example-full-width field-fLex MM16"
        style="vertical-align: middle"
        floatLabel="never"
      >
        <input type="password" #search [formControl]="gmailPassword" matInput />
        <mat-error
          class="error_flex"
          *ngIf="gmailPassword.touched && gmailPassword.hasError('required')"
        >
          Enter Password
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!--Submit Btn-->
  <div class="row row_flex mt-0" *ngIf="data.configType != 'other'">
    <div class="col-md-4">
      <button
        mat-raised-button
        class="MM24"
        color="primary"
        [disabled]="!gmailUser.valid || !gmailPassword.valid"
        (click)="configureMail()"
      >
        Submit
      </button>
    </div>
  </div>

  <!--Divider-->
  <!--<div class="row row_flex">
    <div class="col-md-5">
      <div class="divider"></div>
    </div>
    <div class="col-md-2 text-center">
      <span class="MM18 font-weight-bold" style="color: #013cdb">-OR-</span>
    </div>
    <div class="col-md-5">
      <div class="divider"></div>
    </div>
  </div>-->

  <!--Other Email Registration-->
  <div class="row_flex" *ngIf="data.configType === 'other'" [formGroup]="registerForm">
    <div class="row col_flex">
      <div class="col-md-6">
        <mat-label class="label-flex">
          Username <span class="text-danger">*</span>
        </mat-label>
        <mat-form-field
          class="example-full-width field-fLex MM16"
          style="vertical-align: middle"
          floatLabel="never"
        >
          <input type="text" formControlName="userName" matInput />
          <mat-error
            class="error_flex"
            *ngIf="
              registerForm.controls['userName'].touched &&
              registerForm.controls['userName'].hasError('required')
            "
          >
            Enter Username
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="label-flex">
          Password <span class="text-danger">*</span>
        </mat-label>
        <mat-form-field
          class="example-full-width field-fLex MM16"
          style="vertical-align: middle"
          floatLabel="never"
        >
          <input type="password" formControlName="password" matInput />
          <mat-error
            class="error_flex"
            *ngIf="
              registerForm.controls['password'].touched &&
              registerForm.controls['password'].hasError('required')
            "
          >
            Enter Password
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row col_flex">
      <div class="col-md-6">
        <mat-label class="label-flex">
          IMAP Server <span class="text-danger">*</span>
        </mat-label>
        <mat-form-field
          class="example-full-width field-fLex MM16"
          style="vertical-align: middle"
          floatLabel="never"
        >
          <input type="text" formControlName="imapServer" matInput />
          <mat-error
            class="error_flex"
            *ngIf="
              registerForm.controls['imapServer'].touched &&
              registerForm.controls['imapServer'].hasError('required')
            "
          >
            Enter IMAP Server Name
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="label-flex">
          IMAP Port <span class="text-danger">*</span>
        </mat-label>
        <mat-form-field
          class="example-full-width field-fLex MM16"
          style="vertical-align: middle"
          floatLabel="never"
        >
          <input type="text" formControlName="imapPort" matInput />
          <mat-error
            class="error_flex"
            *ngIf="
              registerForm.controls['imapPort'].touched &&
              registerForm.controls['imapPort'].hasError('required')
            "
          >
            Enter IMAP Port
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row col_flex">
      <div class="col-md-6">
        <mat-label class="label-flex">
          SMTP Server <span class="text-danger">*</span>
        </mat-label>
        <mat-form-field
          class="example-full-width field-fLex MM16"
          style="vertical-align: middle"
          floatLabel="never"
        >
          <input type="text" formControlName="smtpServer" matInput />
          <mat-error
            class="error_flex"
            *ngIf="
              registerForm.controls['smtpServer'].touched &&
              registerForm.controls['smtpServer'].hasError('required')
            "
          >
            Enter SMTP Server Name
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="label-flex">
          SMTP Port<span class="text-danger">*</span>
        </mat-label>
        <mat-form-field
          class="example-full-width field-fLex MM16"
          style="vertical-align: middle"
          floatLabel="never"
        >
          <input type="text" formControlName="smtpPort" matInput />
          <mat-error
            class="error_flex"
            *ngIf="
              registerForm.controls['smtpPort'].touched &&
              registerForm.controls['smtpPort'].hasError('required')
            "
          >
            Enter SMTP Port
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row col_flex">
      <div class="col-md-12">
        <mat-checkbox class="MM24" style="font-weight: 500;" formControlName="termsAndConditions"
          >I agree to all the
          <span class="font-weight-bold">terms & conditions</span></mat-checkbox
        >
      </div>
    </div>
  </div>
  <!--Submit Btn-->
  <div class="row row_flex" *ngIf="data.configType === 'other'">
    <div class="col-md-12">
      <button
        mat-raised-button
        class="MM24"
        color="primary"
        [disabled]="
          !registerForm.valid || registerForm.value.termsAndConditions === false
        "
        (click)="configureMail()"
      >
        Submit
      </button>
    </div>
  </div>
</mat-dialog-content>
